import { IMenuList } from '~/src/dash/types/menuList';

export interface IStreamType {
  name: string;
  key: string;
}

export const streamTypes: IStreamType[] = [
  { name: 'Live', key: '1' },
  { name: 'VOD', key: '2' },
  { name: 'RealtimeVOD', key: '3' },
  { name: 'Empty String', key: 'Empty String' },
  { name: 'Unknown', key: 'Unknown' },
];

export function createAllStreamTypesMenuList(): IMenuList {
  const out = {} as IMenuList;
  streamTypes.forEach((sT) => {
    out[sT.key] = {
      ID: sT.key,
      selected: false,
      title: sT.name,
    };
  });
  return out;
}
